export default "45356e54db15a4b0.svg"